<template>
  <Modal :show-modal="modalStatus" @cancel="closeModal">
    <template v-if="isOtpSent === false" v-slot:header>
      <p class="text-xl font-bold text-main-color">{{ $t('action.changepassword') }}</p>
    </template>
    <template v-if="isOtpSent === false" v-slot:content>
      <Form
        @submit="detectInputType"
        class="flex flex-col gap-2"
        :validation-schema="passwordResetModalSchema()"
      >
        <div class="flex flex-col gap-1">
          <label class="text-start font-bold text-main-color mb-2" for="username">
            {{ $t('form.email') }} / {{ $t('form.phone') }}
          </label>
          <Field
            v-model="formData.username"
            class="p-4 w-full z-10 text-main-color bg-white rounded border border-gray-300 focus:outline-none text-sm"
            type="text"
            name="username"
            id="username"
            autocomplete="username"
          ></Field>
          <ErrorMessage name="username" class="text-red-500 text-start" />
        </div>
        <div class="mt-5 flex flex-col gap-2">
          <label for="password" class="text-start font-semibold text-main-color">{{
            $t('form.newPassword')
          }}</label>
          <Field
            v-model="formData.password"
            name="password"
            id="password"
            type="password"
            autocomplete="new-password"
            class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4"
          ></Field>
          <ErrorMessage name="password" class="text-red-500 text-left"></ErrorMessage>
        </div>
        <div class="mt-5 flex flex-col gap-2">
          <label for="confirmPassword" class="text-start font-semibold text-main-color">{{
            $t('form.passwordRepeat')
          }}</label>
          <Field
            v-model="formData.confirmPassword"
            name="confirmPassword"
            id="confirmPassword"
            type="password"
            autocomplete="new-password"
            class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4"
          ></Field>
          <ErrorMessage name="confirmPassword" class="text-red-500 text-left"></ErrorMessage>
        </div>
        <div class="flex items-center justify-between gap-2 mt-5 text-base">
          <SubmitBtn type="submit" class="text-base !w-full" :loading="loading">{{
            $t('action.renewPassword')
          }}</SubmitBtn>
        </div>
      </Form>
    </template>
    <template v-if="isOtpSent == true" v-slot:header>{{ $t('page.verification_code') }}</template>
    <template v-if="isOtpSent == true" v-slot:content>
      <Form @submit="postResetPassword" class="flex flex-col gap-2">
        <p class="mb-2 text-main-color">{{ $t('page.verification_code_sent') }}</p>
        <OTPInput v-model="formData.code" class="my-2" :fields="6"></OTPInput>

        <p v-if="countDown > 0" class="text-center font-medium mb-2">{{ countDown }}s</p>
        <button
          v-else
          type="button"
          @click.prevent="detectInputType"
          class="mb-5 text-accent-color ease-linear transition-all duration-150"
        >
          {{ $t('page.resend_code') }}
        </button>
        <SubmitBtn type="submit" class="!w-full">{{ $t('action.verify') }}</SubmitBtn>
      </Form>

      <!-- <button @click="toLogin" class="text-start">{{ $t('page.no_account') }} <span
                    class="text-gp-orange font-medium hover:text-gp-orange-red ease-linear transition-all duration-150">{{
        $t('action.register') }}</span></button> -->
    </template>
  </Modal>
</template>

<script>
import { passwordResetModalSchema } from '@/schemas';
import { Field, Form, ErrorMessage } from 'vee-validate';
import OTPInput from '@cmp/OTPInput.vue';

import Modal from '@cmp/Modal.vue';
import api from '@/api';
import { i18n } from '@/i18n';
import { useAppStore } from '@/store';

export default {
  name: 'PasswordResetModal',
  components: {
    Modal,
    Field,
    Form,
    ErrorMessage,
    OTPInput,
  },
  data() {
    return {
      store: useAppStore(),

      loading: false,
      showModal: false,
      isOtpSent: false,

      passwordResetModalSchema: passwordResetModalSchema,
      countDown: 60,
      formData: {
        username: null,
        code: null,
        password: null,
        confirmPassword: null,
      },
    };
  },
  methods: {
    closeModal() {
      // this.showModal = false
      this.isOtpSent = false;
      this.formData = {
        username: null,
        code: null,
        password: null,
        confirmPassword: null,
      };
      this.store.setState('resetLoginPasswordModal', false);
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    detectInputType() {
      const username = String(this.formData.username || '').trim();
      this.formData.username = username;

      const phoneRegex = /^\+993\d{8}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (phoneRegex.test(username)) {
        this.sendCodePhone();
        return;
      }

      if (emailRegex.test(username)) {
        this.sendCodeEmail();
        return;
      }

      this.$toast.error('Введите корректный email или телефон');
    },

    async postResetPassword() {
      try {
        const username = String(this.formData.username || '').trim();
        const phoneRegex = /^\+993\d{8}$/;

        const payload = {
          code: Number(this.formData.code),
          password: this.formData.password,
          password2: this.formData.confirmPassword,
        };

        if (phoneRegex.test(username)) {
          payload.phone = username;
        } else {
          payload.email = username.toLowerCase();
        }

        await api.post('password_reset', payload);

        this.$toast.info(`${i18n.global.t('warning.PASSWORD_UPDATED')}`);
        this.closeModal();
        this.store.setState('loginModal', true);
      } catch (e) {
        console.log(e);
      }
    },
    async sendCodePhone() {
      try {
        this.countDown = 60;
        this.countDownTimer();
        await api.post('code/phone/', {
          phone: this.formData.username,
        });
        this.isOtpSent = true;
      } catch (e) {
        console.log(e);
      }
    },
    async sendCodeEmail() {
      try {
        this.countDown = 60;
        this.countDownTimer();
        await api.post('code/email/', {
          email: this.formData.username,
        });
        this.isOtpSent = true;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    modalStatus() {
      return this.store.resetLoginPasswordModal;
    },
  },
};
</script>
